module.exports = __webpack_public_path__ + "static/media/aam-personal.9bc7cd3c.jpg";